import { PlainTooltip } from "@similarweb/ui-components";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { ReactElement } from "react";
import { StyledHelpIconButton } from "./styles";

type HelpButtonProps = {
    className?: string;
    tooltipContent?: ReactElement;
    onClick(): void;
};

const HelpButton = (props: HelpButtonProps) => {
    const {
        tooltipContent = <I18n translatable={{ key: "page.title.education.icon.tooltip" }} />,
        className,
        onClick,
    } = props;

    return (
        <PlainTooltip
            placement="bottom"
            tooltipContent={tooltipContent}
        >
            <div className={className}>
                <StyledHelpIconButton
                    type="flat"
                    iconSize="sm"
                    iconName="learning-hat"
                    onClick={onClick}
                />
            </div>
        </PlainTooltip>
    );
}

export default HelpButton;
